module.exports = __webpack_public_path__ + "static/media/designLogo.518ee964.svg";